"use client";

import { useResolvedCurrentOrganization } from "@/hooks/spacetime/use-current-organization";
import { useCurrentUser, useMyMemberships } from "@/hooks/spacetime";
import { isOrgAdminOrOwner } from "@/lib/org-roles";
import { SubscriptionCanceledToasts } from "./subscription-canceled-toasts";
import { TaxExemptionStatusToasts } from "./tax-exemption-status-toasts";
import { RoleChangedToasts } from "./role-changed-toasts";
import { InviteAcceptedToasts } from "./invite-accepted-toasts";
import { JoinRequestToasts } from "./join-request-toasts";
import { TaxApplicationToasts } from "./tax-application-toasts";
import { OrgFlagToasts } from "./org-flag-toasts";

/**
 * Single global mount point for every live-change toast consumer. Renders
 * nothing. Mounted ONCE inside the connected tree (app-bootstrap) — a second
 * mount would double every toast. Resolves the current org once here (via
 * the internal resolver — the canonical useCurrentOrganization() call site
 * owns the last-selected-org persistence effect, and this must not add
 * another) and hands it to each consumer.
 */
export default function LiveChangeToasts() {
  const { organization } = useResolvedCurrentOrganization();
  const { user } = useCurrentUser();
  const { memberships } = useMyMemberships();
  const isAdmin = isOrgAdminOrOwner(organization, user, memberships);
  return (
    <>
      <TaxApplicationToasts userId={user?.id ?? null} />
      <SubscriptionCanceledToasts organization={organization} />
      <TaxExemptionStatusToasts organization={organization} />
      <RoleChangedToasts organization={organization} />
      <InviteAcceptedToasts organization={organization} enabled={isAdmin} />
      <JoinRequestToasts organization={organization} enabled={isAdmin} />
      <OrgFlagToasts organization={organization} />
    </>
  );
}
